import i18n from "i18n";
import { keepPreviousData, useQuery } from "@tanstack/react-query";
import PaginationURL from "util/PaginationURL";
import FiltersForQueryParams from "components/common/EntityFilters/FiltersForQueryParams";
import { DATA_LAKE_API_ROUTES, DELETED_STREAM_TITLE } from "data-lake/Constants";
import fetch from "logic/rest/FetchProvider";
import { qualifyUrl } from "util/URLUtils";
import { defaultOnError } from "util/conditional/onError";
const INITIAL_DATA = {
  pagination: { total: 0 },
  list: [],
  attributes: []
};
const refetchInterval = 5e3;
export const fetchDataLakes = (searchParams) => {
  const url = PaginationURL(
    DATA_LAKE_API_ROUTES.DataLakeAPIController.paginated().url,
    searchParams.page,
    searchParams.pageSize,
    searchParams.query,
    {
      sort: searchParams.sort.attributeId,
      order: searchParams.sort.direction,
      filters: FiltersForQueryParams(searchParams.filters)
    }
  );
  return fetch("GET", qualifyUrl(url)).then((response) => {
    const {
      elements,
      query,
      attributes,
      pagination: { count, total, page, per_page: perPage }
    } = response;
    return {
      list: elements,
      attributes,
      pagination: {
        count,
        total,
        page,
        perPage,
        query
      }
    };
  });
};
export const loadStreamsDataLakeOptions = ({ page, perPage, query }) => fetchDataLakes({
  page,
  pageSize: perPage,
  query,
  sort: { attributeId: "stream_id", direction: "asc" }
}).then(({ list, pagination }) => ({
  list: list.map(({ stream_title, stream_id }) => ({
    label: stream_title != null ? stream_title : DELETED_STREAM_TITLE,
    value: stream_id
  })),
  pagination: { page: pagination.page, perPage: pagination.perPage, query: pagination.query },
  total: pagination.total
}));
export const keyFn = (searchParams) => ["data-lake", "overview", searchParams];
const useDataLakes = (searchParams, { enabled } = { enabled: true }) => {
  const { data, refetch, isInitialLoading } = useQuery({
    queryKey: keyFn(searchParams),
    queryFn: () => defaultOnError(
      fetchDataLakes(searchParams),
      i18n.t("notifications.fetch_data_lakes_failed", { ns: "enterprise_data_lake" }),
      i18n.t("notifications.fetch_data_lakes_failed_title", { ns: "enterprise_data_lake" })
    ),
    placeholderData: keepPreviousData,
    refetchInterval,
    notifyOnChangeProps: ["data", "error"],
    enabled
  });
  return {
    data: data != null ? data : INITIAL_DATA,
    refetch,
    isInitialLoading
  };
};
export default useDataLakes;
